import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";

import { WithdrawalFormInput } from "@/components/WithdrawalForm/withdrawalFrom.schema";
import BPostService from "@/services/bpost.service";

export const COUNTRY_BE = "BE";

export const getEmptyPrefillAddress = (): WithdrawalFormInput["address"] => {
    return {
        address: "",
        box: "",
        city: "",
        country: COUNTRY_BE,
        number: "",
        street: "",
        zipCode: "",
        selected: false,
        isComplete: false,
        validationStatus: AddressValidationStatus.Unknown
    };
};

export const toNonBePrefillAddress = (
    address: CloudCustomerAddress
): WithdrawalFormInput["address"] => {
    return {
        address: "",
        box: address.box ?? "",
        city: address.city ?? "",
        country: address.country ?? COUNTRY_BE,
        number: address.number ?? "",
        street: address.street ?? "",
        zipCode: address.zipCode ?? "",
        selected: false,
        isComplete: false,
        validationStatus:
            address.validationStatus ?? AddressValidationStatus.Unknown
    };
};

export const toBePrefillAddress = async (
    address: CloudCustomerAddress
): Promise<WithdrawalFormInput["address"]> => {
    const { isValid, newStatus, officialAddress } =
        await BPostService.validateAddress({
            city: address.city,
            number: address.number,
            street: address.street,
            zipCode: address.zipCode,
            box: address.box ?? ""
        });

    if (!isValid) {
        return getEmptyPrefillAddress();
    }

    return {
        country: officialAddress?.country || COUNTRY_BE,
        address: officialAddress?.address || "",
        city: officialAddress?.city || "",
        street: officialAddress?.streetName || "",
        number: officialAddress?.number || "",
        zipCode: officialAddress?.zipCode || "",
        box: officialAddress?.boxNumber || "",
        validationStatus: newStatus || address?.validationStatus
    };
};
